// importando estilização do componente
import React from 'react'
import { Styled } from './Styled'

interface IButtonActionWide {
    click: () => void
    nome: string
}

export const ButtonActionWide: React.FC <IButtonActionWide> = (props) =>{     
    function click (){
        props.click()
    }
    return (  
        <Styled.Content>     
            <button type="button" className='' onClick={click}>
                <span>{props.nome}</span>            
            </button> 
        </Styled.Content>           
    )
}
// aqui estamos exportando nosso componente
